//Реакт
import React, { useState } from 'react';
//Mui Icons
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
//Стили
import "./styles.css";
import "../../styles.css";

export default function Info({
    children,
    className = '',
    messages = [],
    onErrorCheck // Добавляем новый пропс
}) {
    const [isError, setIsError] = useState(false);

    // Вызываем анимацию при получении соответствующего сигнала
    useState(() => {
        if (onErrorCheck) {
            onErrorCheck(() => {
                if (messages.length > 0) {
                    setIsError(true);
                    const timer = setTimeout(() => setIsError(false), 400);
                    return () => clearTimeout(timer);
                }
            });
        }
    }, [onErrorCheck, messages]);

    return (
        <>
            {messages.length > 0 ?
                <div className={`step-buy__tooltip ${isError ? 'step-buy__tooltip--error' : ''}`}>
                    {messages.map((message, index) => (
                        <div className="step-buy__tooltip-data" key={index}>
                            <div className="step-buy__tooltip-data-icon">
                                <InfoOutlinedIcon />
                            </div>
                            <div className="step-buy__tooltip-data-label">
                                {message}
                            </div>
                        </div>
                    ))}
                </div>
            : null}
        </>
    );
}
